import script from "./Property.vue?vue&type=script&setup=true&lang=js"
export * from "./Property.vue?vue&type=script&setup=true&lang=js"

import "./Property.vue?vue&type=style&index=0&id=6ac13202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac13202"]])

export default __exports__